<div class="rs-flex-row">
  <div class="rs-flex-column">
    <p
      *ngIf="section; else sectionItem"
      class="rs-txt-primary"
      [ngClass]="{ 'rs-font-pxB': categoryType === 'thirdParty' }"
      data-cy="myBillOdbCategoryDetailsSectionV1"
    >
      <span [ngClass]="{ 'rs-font-pxB': categoryType !== 'thirdParty' }">{{
        title
      }}</span>
      <ng-container *ngIf="subtitle">
        <br /><span class="rs-txt-details"> {{ subtitle }}</span>
      </ng-container>
    </p>
    <ng-template #sectionItem>
      <ul
        [attr.aria-labelledby]="title"
        class="rs-padding-left2"
        data-cy="myBillOdbCategoryDetailsItemV1"
      >
        <li>
          {{ title }}
          <ng-container *ngIf="subtitle">
            <br /><span class="rs-txt-details"> {{ subtitle }}</span>
          </ng-container>
        </li>
      </ul>
    </ng-template>
  </div>
  <div class="rs-flex-column rs-flex-shrink">
    <p *ngIf="amount" class="rs-font-pxB">
      <px-currency-amount [amount]="amount"></px-currency-amount>
    </p>
  </div>
</div>
<ng-container *ngFor="let item of section?.items">
  <div class="rs-margin-top2-neg">
    <my-bill-odb-category-section-or-item-variant-one
      [item]="item"
      [categoryDetailValidFor]="categoryDetailValidFor"
    >
    </my-bill-odb-category-section-or-item-variant-one>
  </div>
</ng-container>
